module.exports = __webpack_public_path__ + "430b9adf1d164cc421bd2d1c56c53f9c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/bookshelves/bookshelf-pirate.png
// module id = 966
// module chunks = 0